/**
 * Thin API client for /api/training/* endpoints.
 *
 * All callers authenticate via the JWT from localStorage.
 */
import axios from "axios";
import { API } from "@/App";

function authHeader() {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function listTopics() {
  const r = await axios.get(`${API}/training/topics`, { headers: authHeader() });
  return r.data;
}

export async function getTopic(slug) {
  const r = await axios.get(`${API}/training/topics/${encodeURIComponent(slug)}`, {
    headers: authHeader(),
  });
  return r.data;
}

export async function getProgress() {
  const r = await axios.get(`${API}/training/progress`, { headers: authHeader() });
  return r.data;
}

export async function patchProgress(payload) {
  const r = await axios.patch(`${API}/training/progress`, payload, { headers: authHeader() });
  return r.data;
}

export async function chat(payload) {
  const r = await axios.post(`${API}/training/chat`, payload, { headers: authHeader() });
  return r.data;
}
